import React from "react";
import { FullScreenDialog } from "../core/FullScreenDialog";
import Image from "mui-image";
import Box from "@mui/material/Box";
import { assetPath } from "../endpoints";
import LinkOff from "@mui/icons-material/LinkOff";

/**
 * @param {object} props
 * @param {string} props.imageSrc - The S3 location of the image
 * @param {React.ReactNode} props.children - The trigger element (usually the thumbnail image)
 * @param {string} [props.alt] - Alt text for the image
 */
export const FullScreenImageViewer = ({ imageSrc, children, alt = "" }) => {
  return (
    <FullScreenDialog title="" canSave={false} CustomControl={children}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          height: "75vh",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Image alt={alt} src={assetPath(imageSrc)} fit="contain" width="100%" height="100%" errorIcon={<LinkOff />} />
      </Box>
    </FullScreenDialog>
  );
};
